module.exports = __webpack_public_path__ + "img/remilia scarlet.1f7fa8f1.png";